import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'weekday',
  standalone: true
})
/**
 * 將 yyyyMMdd 格式（例如：20260407）轉換為星期（例如：星期二）
 */
export class WeekdayPipe implements PipeTransform {
  transform(value: string): string {
    // 驗證格式是否為 8 位數字
    if (!/^\d{8}$/.test(value)) {
      return '';
    }

    // 解析字串為日期組件
    const year = parseInt(value.substring(0, 4), 10);
    const month = parseInt(value.substring(4, 6), 10) - 1; // 月份從 0 開始
    const day = parseInt(value.substring(6, 8), 10);

    const date = new Date(year, month, day);

    // 檢查日期是否合法 (例如防止 20260230 這種日期)
    if (isNaN(date.getTime())) {
      return '';
    }

    // 使用原生 Intl 格式化輸出
    // 'zh-TW' 搭配 { weekday: 'long' } 會輸出「星期二」
    // 若改為 'short' 則輸出「週二」
    return new Intl.DateTimeFormat('zh-TW', { weekday: 'long' }).format(date);
  }
}